// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	SearchAutoComplete: 'search-auto-complete',
	CreateLawFirmButton: 'create-law-firm-button',
	LawyerNameBadge: 'lawyer-name-badge',
	ClerkNameBadge: 'clerk-name-badge',
	LawFirmItemDiv: 'law-firm-item-div',
	LawyerItemDiv: 'lawyer-item-div',
	ClerkItemDiv: 'clerk-item-div',
} as const;
